// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1-7AX","upload":"Small_upload__2_PBx","imageWrap":"Small_imageWrap__3LXqI","removeBtn":"Small_removeBtn__1-dxi"};